/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/autoCapitalizationFilter.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoAutoCapitalizationCityField implements angular.IDirective {
    restrict = "E";
    scope = {
      name: "@",
      currentCityValue: "=ngModel",
      contentKey: "@",
      disabled: "=ngDisabled",
      required: "=ngRequired",
      fieldFilter: "@",
      change: "&ngChange", 
      tabIndex: "=?",
      cityLength: "="
    };

    
   
      template = "<div><div class=\"meevo_input_wrapper\"><label translate=\"{{contentKey}}\"  aria-label='{{ contentKey | translate}}'></label><div ng-class=\"{'ng-dirty required_red_bubble ' : required && !currentCityValue}\"></div></div><input id=\"{{ contentKey + $parent.$index }}\" autocomplete='off'  aria-label='{{ contentKey | translate}}' title='{{ contentKey | translate }}'  ng-class=\"{'red_border_invalid' : (required && !currentCityValue) || !isValid }\" type=\"text\" name=\"{{name}}\" ng-model=\"maskedValue\" ng-model-options=\"{'updateOn': 'default blur','debounce': {'default': 250,'blur': 0}}\" ng-disabled=\"disabled\" ng-required=\"required\" tabindex=\"{{tabIndex || 0}}\" /></div>";
        
    constructor(private $filter: angular.IFilterService, private $compile: angular.ICompileService) {

    }

    link = (scope: any, element: JQuery, attrs: angular.IAttributes, formCtrl: angular.IFormController) => {
      var filter = this.$filter;
      scope.fieldFilter = 'meevoAutoCapitalization';

      attrs.$observe('fieldFilter', function(val) {
        if (angular.isDefined(val)) {
          scope.fieldFilter = val;
        }
      });

      scope.$watch('currentCityValue', currentVal => {
        var newMaskedVal = "";

        newMaskedVal = filter(scope.fieldFilter)(currentVal);

        if (scope.maskedValue !== newMaskedVal) {
          scope.maskedValue = newMaskedVal;
        }

        if (currentVal && !_.isEmpty(currentVal)) {
          scope.change();
        }
      });

      scope.$watch('currentCityValue', currentVal => {
          if (currentVal) {
              if (scope.cityLength && currentVal.length > scope.cityLength)
                  scope.isValid = false;
              else
                  scope.isValid = true;
          }
          else
              scope.isValid = true;
      });

      scope.$watch('maskedValue', maskedVal => {
        var newUnmaskedVal = "";

        newUnmaskedVal = maskedVal; // doesn't need to be unmasked

        if (scope.currentCityValue !== newUnmaskedVal) {
          scope.currentCityValue = newUnmaskedVal;
        }
      });

      element.on("click", (event: JQueryEventObject) => {
        if (!scope.isDisabled) {
          let target: any = event.target || event.srcElement;
          if (target.id === scope.id) {
            target.select();
          }
          event.preventDefault();
        }
      });
    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($filter, $compile) => {
        return new MeevoAutoCapitalizationCityField($filter, $compile);
      };

      directive.$inject = ["$filter", "$compile"];

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoAutoCapitalizationCityField", MeevoAutoCapitalizationCityField.factory());
}